import { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AppContext, { AppContextProps } from '../components/infrastructure/appContext';
import { Core } from '../components/infrastructure/core';

interface IErrorBoundaryProps {

}
interface IErrorBoundaryStates {
    hasError: boolean;
}

export class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryStates> {
    static contextType = AppContext;
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error: any, errorInfo: any) {
        if (process.env.NODE_ENV === 'production') {
            const { path, params } = this.context as AppContextProps;
            const referenceUrl = Core.getUrl(path, params);
            Core.logError(referenceUrl, error.message, error.stack);
            this.setState({ hasError: true });
        }
        else
            console.error(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            const { path, params } = this.context as AppContextProps;
            let returnUrl = '';
            const url = Core.getUrl(path, params);
            if (url !== '')
                returnUrl = '?returnUrl=' + url;
            let errorPageUrl = '/errorpage';
            return (<Redirect to={{ pathname: errorPageUrl, search: returnUrl }} />);
        }
        return this.props.children;
    }
}

